<template>
  <div class="break section-block row-box">
    <WrapperField
      v-for="(fieldValue, fieldName) in data"
      :key="fieldValue + fieldName"
      :data="
        createDataField({
          fieldName,
          fieldValue,
          fieldGroup: FieldGroup.EXTRACTION_ROD_DETAILS,
        })
      "
    ></WrapperField>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

export default {
  name: 'Step2',
  components: {
    WrapperField,
  },
  props: ['data'],
  data: () => ({
    createDataField,
    FieldGroup,
  }),
};
</script>
